import {Component, OnInit} from '@angular/core';
import {BaseService} from '../../base.service';
import {SliderService} from '../../services/slider.service';
import {Location} from '@angular/common';
import {Router, ActivatedRoute} from '@angular/router';
import {FormBuilder} from '@angular/forms';
import {SliderDto} from '../../dto/slider.dto';
import { ContractsService } from '../../services/contracts.service';
import { Contract } from '../../models/contract';
import { multicast } from 'rxjs/operators';
import { environment } from '../../../environments/environment.local';
import { Env } from '../../env';
import { Property } from '../../models/property';
import { PropertyService } from '../../services/property.service';
import { DivisionService } from '../../services/division.service';
import { PaymentService } from '../../services/payment.service';
import { DivisionPItem } from '../../models/DivisionPItem';
import { PaymentPItem } from '../../models/paymentPItem';
import { TenantService } from '../../services/tenant.service';
import { Tenant } from '../../models/tenant';

//import { TabComponent  } from '../tabset/tab.component';

@Component({
  selector: 'app-tenant',
  templateUrl: './tenant.component.html',
  styleUrls: ['./tenant.component.css']
})
export class TenantComponent implements OnInit {

  private titleComponent: string;
  private titlePanel: string;

  constructor(
    private baseService: BaseService,
    private paymentService: PaymentService,
    private tenantService: TenantService,
    private location: Location,
    private router: Router,
    private route: ActivatedRoute,
    private fb: FormBuilder,
    private env: Env
  ) {}
  
  tenant:Tenant = {
    id : 0,
    dni: "",
    email: "",
    lastName: "",
    creationDate: "",
    name: "",
    phoneNumber: "",
    status: true,
  };
  divisions:DivisionPItem[] = [];
  payments:PaymentPItem[] = [];

  paymentTotal = 10000000;
  paymentBigCurrentPage: number = 1;
  paymentMaxSize: number = 5;
  paymentsize: number = 10;
  paymentPage: number = 1;
  paymentStatus: string = '';

  ngOnInit() {
    this.titleComponent = 'Inquilino';
    this.titlePanel = 'Detalle de Inquilino';
    this.baseService.changedComponentName(this.titleComponent);
    this.get();
    this.listPayment();
  }

  
  listPayment(page:number = 0){
    let tenantId = this.route.snapshot.paramMap.get('id');
    this.paymentService.getAllByProperty(tenantId,page).subscribe( r => {
      console.log(r);
      //this.payments = r.content;
      
      if (r) {
        
        let data:any = r;
        this.payments = data.content;
        /*pPayments.map( r => {
          this.contracts.push( {
            id: r.id,
            tenantFullName: r.tenant.name + ' ' + r.tenant.lastName,
            tenantDNI: r.tenant.dni,
            status: r.status,
            propertyFullName: r.property.fullName,
            propertyDNI: r.property.dni,
            propertyRUC: r.property.ruc,
            cantidad : r.amount,
            amountToReceive: r.amountToReceive + ' ' + r.currencyCode,
            creationDate: r.creationDate,
            dayMonth: r.dayMonth,
            divisionName: r.division.name
          } );
        });*/
        this.paymentTotal = data.totalElements;
        this.paymentPage = data.number;
        
      }

      console.log(this.divisions);
    } , err => {
      console.log(err);
    });   
  }

  get(){
    let id = this.route.snapshot.paramMap.get('id');
    this.tenantService.get(id).subscribe( r => {
      console.log(r);
      this.tenant = r;

    } , err => {
      console.log(err);
    });
  }

  goBack(): void {
    this.location.back();
  }

  paymentPageChanged(event: any): void {
    this.listPayment( event.page -1 );
  }
  /*
-status
  Pendiente
  Activo
  -status de pago
  Activo("A"),
  Moroso("M"),
  Deudor("D"),
  concluido("F"),
  pendiente("P");
  */
}



// WEBPACK FOOTER //
// D:/padriana/gorent-panel/src/app/dashboard/tenant/tenant.component.ts